import { IconShowSubtitle } from "components/icons";
import * as React from "react";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonViewDetails: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonViewDetails.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconShowSubtitle  fixedWidth />
        </MprcIconButton>
    );
};
